import { Component, OnInit } from '@angular/core';
import { IpService } from '../_service/ip.service';
import { IspService } from '../_service/isp.service';
import { StoreService } from '../_service/store.service';
import { ServerService } from '../_service/server.service';
import { HelperService } from '../_service/helper.service';

@Component({
    selector: 'footerapp',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.css'],
})
export class FooterComponent implements OnInit {

    ip: string;
    ipv4: string;
    ipv6: string;
    isp: string;

    constructor(private ipService: IpService,
                private ispService: IspService,
                private storeService: StoreService,
                private serverService: ServerService,
                private helperService: HelperService) {
    }

    ngOnInit() {
        this.load();
    }

    load() {
        this.ispService.getIsp()
            .subscribe(
                data => {
                    // console.log(data)
                    this.helperService.processIsp(data);

                    if (data.ipType == 'IPv6') {
                        let ipv6 = data.query;
                        this.ipv6 = ipv6;
                        this.storeService.test.ipv6 = ipv6;
                    }

                    let isp = data.isp;
                    this.isp = isp;
                    this.storeService.ispName = isp;

                    this.serverService.getServer()
                        .subscribe(
                            data => {
                                this.storeService.servers = data;
                                this.helperService.setClosestServer();
                            },
                            error => {
                                // console.log('error: ', error);
                            });

                },
                error => {
                    // console.log('error: ', error);
                });

        this.ipService.getIp()
            .subscribe(
                data => {
                    if (data.type == 'IPv4') {
                        let ipv4 = data.ip;
                        this.ipv4 = ipv4;
                        this.storeService.test.ip = ipv4;
                    }
                },
                error => {
                    // console.log('error: ', error);
                });
    }


}
